import { Routes, Route } from "react-router-dom";
import {
	faBook,
	faCogs,
	faEnvelopes,
	faFolder,
	faHome,
	faUser,
	faUsers,
} from "@fortawesome/pro-regular-svg-icons";

import PublicRoute from "./PublicRoute";
import PrivateRoute from "./PrivateRoute";

import Page404 from "../views/errors/Page404";

import PageLogin from "../views/public/PageLogin/PageLogin";

import PageDashboard from "../views/private/PageDashboard/PageDashboard";
import PageEditProfile from "../views/private/PageEditProfile/PageEditProfile";
import PageProfiling from "../views/private/PageProfiling/PageProfiling";
import PageProfilingAdd from "../views/private/PageProfiling/PageProfilingAdd";
import PageThesis from "../views/private/PageThesis/PageThesis";
import PageThesisAdd from "../views/private/PageThesis/PageThesisAdd";
import PageThesisEdit from "../views/private/PageThesis/PageThesisEdit";
import PageSettings from "../views/private/PageRef/PageSettings";
import ModalAddAuthor from "../views/private/PageThesis/components/ModalAddAuthor";
import PageEmailTemplate from "../views/private/PageEmailTemplate/PageEmailTemplate";
import PageHome from "../views/public/PageHome/PageHome";
import SearchHomePage from "../views/public/PageHome/SearchHomePage";
import PageSearchedItem from "../views/public/PageHome/PageSearchedItem";

export default function RouteList() {
	return (
		<Routes>
			<Route
				path="/login"
				element={
					<PublicRoute title="LOGIN" pageId="PageLogin" component={PageLogin} />
				}
			/>
			<Route path="/" element={<PageHome title="LOGIN" pageId="PageHome" />} />
			<Route
				path="/search"
				element={<SearchHomePage title="LOGIN" pageId="SearchHomePage" />}
			/>
			<Route
				path="/item/:id"
				element={<PageSearchedItem title="LOGIN" pageId="PageSearchItem" />}
			/>

			<Route
				path="/edit-profile"
				element={
					<PrivateRoute
						moduleName="Edit Profile"
						title="User"
						subtitle="VIEW / EDIT"
						pageId="PageUserProfile"
						pageHeaderIcon={faUsers}
						breadcrumb={[
							{
								name: "Dashboard",
								link: "/dashboard",
							},
							{
								name: "Edit Profile",
							},
						]}
						component={PageEditProfile}
					/>
				}
			/>

			<Route
				path="/dashboard"
				element={
					<PrivateRoute
						moduleCode="M-01"
						moduleName="Dashboard"
						title="Dashboard"
						subtitle="ADMIN"
						pageId="PageDashboard"
						pageHeaderIcon={faHome}
						breadcrumb={[
							{
								name: "Dashboard",
							},
						]}
						component={PageDashboard}
					/>
				}
			/>

			<Route
				path="/thesis/books"
				element={
					<PrivateRoute
						moduleCode="M-01"
						moduleName="Thesis"
						title="Books"
						subtitle="ADMIN"
						pageId="PageThesis"
						pageHeaderIcon={faBook}
						breadcrumb={[
							{
								name: "Dashboard",
								link: "/dashboard",
							},

							{
								name: "Books",
							},
						]}
						component={PageThesis}
					/>
				}
			/>

			<Route
				path="/thesis/books/add"
				element={
					<PrivateRoute
						moduleCode="M-01"
						moduleName="Thesis"
						title="Thesis"
						subtitle="ADMIN"
						pageId="PageThesis"
						pageHeaderIcon={faBook}
						breadcrumb={[
							{
								name: "Dashboard",
								link: "/dashboard",
							},
							{
								name: "Books",
								link: "/thesis/books",
							},
							{
								name: "Add",
							},
						]}
						component={PageThesisAdd}
					/>
				}
			/>

			<Route
				path="/thesis/books/edit/:id"
				element={
					<PrivateRoute
						moduleCode="M-01"
						moduleName="Thesis"
						title="Thesis"
						subtitle="ADMIN"
						pageId="PageThesis"
						pageHeaderIcon={faBook}
						breadcrumb={[
							{
								name: "Dashboard",
								link: "/dashboard",
							},
							{
								name: "Books",
								link: "/thesis/books",
							},
							{
								name: "Edit",
							},
						]}
						component={PageThesisEdit}
					/>
				}
			/>
			<Route
				path="/thesis/books/edit/:id/add"
				element={
					<PrivateRoute
						moduleCode="M-01"
						moduleName="Thesis"
						title="Thesis"
						subtitle="ADMIN"
						pageId="PageThesis"
						pageHeaderIcon={faBook}
						breadcrumb={[
							{
								name: "Dashboard",
								link: "/dashboard",
							},
							{
								name: "Books",
								link: "/thesis/books",
							},
							{
								name: "Edit",
							},
						]}
						component={ModalAddAuthor}
					/>
				}
			/>

			<Route
				path="/thesis/archived"
				element={
					<PrivateRoute
						moduleCode="M-01"
						moduleName="Thesis"
						title="Archived"
						subtitle="ADMIN"
						pageId="PageThesis"
						pageHeaderIcon={faFolder}
						breadcrumb={[
							{
								name: "Dashboard",
								link: "/dashboard",
							},
							{
								name: "Books",
								link: "/thesis/books",
							},
							{
								name: "Archived",
							},
						]}
						component={PageThesis}
					/>
				}
			/>

			<Route
				path="/users/current"
				element={
					<PrivateRoute
						moduleCode="M-01"
						moduleName="Profiling"
						title="Users"
						subtitle="ADMIN"
						pageId="PageProfiling"
						pageHeaderIcon={faUsers}
						breadcrumb={[
							{
								name: "Dashboard",
								link: "/dashboard",
							},
							{
								name: "Books",
								link: "/thesis/books",
							},
							{
								name: "Archived",
								link: "/thesis/archived",
							},
							{
								name: "Users",
							},
						]}
						component={PageProfiling}
					/>
				}
			/>
			<Route
				path="/users/current/add"
				element={
					<PrivateRoute
						moduleCode="M-01"
						moduleName="Profiling"
						title="Users"
						subtitle="ADMIN"
						pageId="PageProfiling"
						pageHeaderIcon={faUsers}
						breadcrumb={[
							{
								name: "Dashboard",
								link: "/dashboard",
							},
							{
								name: "Books",
								link: "/thesis/books",
							},
							{
								name: "Archived",
								link: "/thesis/archived",
							},
							{
								name: "Users",
								link: "/users/current",
							},
							{
								name: "Add",
							},
						]}
						component={PageProfilingAdd}
					/>
				}
			/>

			<Route
				path="/users/current/edit-profile/:id"
				element={
					<PrivateRoute
						moduleName="Edit Profile"
						title="User"
						subtitle="VIEW / EDIT"
						pageId="PageUserProfile"
						pageHeaderIcon={faUsers}
						breadcrumb={[
							{
								name: "Dashboard",
								link: "/dashboard",
							},
							{
								name: "Books",
								link: "/thesis/books",
							},
							{
								name: "Archived",
								link: "/thesis/archived",
							},
							{
								name: "Current",
								link: "/users/current",
							},
							{
								name: "Edit Profile",
							},
						]}
						component={PageEditProfile}
					/>
				}
			/>

			<Route
				path="/users/archived"
				element={
					<PrivateRoute
						moduleCode="M-01"
						moduleName="Users"
						title="Users"
						subtitle="ADMIN"
						pageId="PageProfiling"
						pageHeaderIcon={faUsers}
						breadcrumb={[
							{
								name: "Dashboard",
								link: "/dashboard",
							},
							{
								name: "Books",
								link: "/thesis/books",
							},
							{
								name: "Archived",
								link: "/thesis/archived",
							},
							{
								name: "Current",
								link: "/users/current",
							},
							{
								name: "Archived",
							},
						]}
						component={PageProfiling}
					/>
				}
			/>

			<Route
				path="/thesis/settings"
				element={
					<PrivateRoute
						moduleCode="M-01"
						moduleName="Users"
						title="Settings"
						subtitle="ADMIN"
						pageId="PageProfiling"
						pageHeaderIcon={faCogs}
						breadcrumb={[
							{
								name: "Dashboard",
								link: "/dashboard",
							},
							{
								name: "Settings",
							},
						]}
						component={PageSettings}
					/>
				}
			/>

			<Route
				path="/thesis/email"
				element={
					<PrivateRoute
						moduleCode="M-01"
						moduleName="Users"
						title="Email Template"
						subtitle="ADMIN"
						pageId="PageProfiling"
						pageHeaderIcon={faEnvelopes}
						breadcrumb={[
							{
								name: "Dashboard",
								link: "/dashboard",
							},
							{
								name: "Email Template",
							},
						]}
						component={PageEmailTemplate}
					/>
				}
			/>

			<Route path="/404" element={<Page404 />} />
			<Route path="/*" element={<Page404 />} />
		</Routes>
	);
}
